// MODVIDEO thumb → player: clicking a `.modvideo-trigger` thumb fetches the
// item's `.ajax` view (the `_ajax/modvideo_full` player markup) and swaps it
// into the wrapper named by `data-selector`, in place of the thumb. Delegated
// at the document so it survives ASwap page swaps without re-binding.
export const initModvideo = () => {
  document.addEventListener('click', onDocClick);
};

const onDocClick = (e: MouseEvent) => {
  const link = (e.target as Element).closest<HTMLAnchorElement>('a.modvideo-trigger');
  if (!link) return;
  e.preventDefault();

  const url = link.dataset.url;
  const selector = link.dataset.selector;
  const wrapper = selector ? document.querySelector(selector) : null;

  if (!url || !wrapper || link.classList.contains('loading')) return;

  link.classList.add('loading');

  fetch(url)
    .then((r) => r.text())
    .then((html) => {
      wrapper.innerHTML = html;
    })
    .catch(() => {
      link.classList.remove('loading');
    });
};
